import { Card, CardContent, CardHeader, Grid, MenuItem, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import FormSelect from "../forms/form-select/FormSelect";
import { deviceViews, groupViews } from "./AccountSettingsV2Utils";
import { getObjectTypeName } from "../../common/utilities/GetObjectTypeName";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { UIViewEnum } from "../../common/enums/UIViewEnum";

export default function DefaultViewsCard() {

    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Card
            raised={true}
            sx={{
                flex: "0 0 auto",
                margin: theme.spacing(1),
                padding: theme.spacing(2)
            }}
        >
            <CardHeader
                sx={{
                    padding: 1
                }}
                //title={userState.user?.displayText}
                title={t('profile.defaultViews')}
                slotProps={{
                    title: { 
                        sx: {
                            fontWeight: "bold", 
                        },
                        variant: 'h5', 
                        //marginLeft: 2 
                    }
                }}
            />
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >

                <Grid container spacing={2}>

                    <Grid size={{ xs: 12 }}>
                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {getObjectTypeName(eLynxObjectTypeEnum.Group)}
                        </Typography>

                        <FormSelect
                            name="defaultGroupView"
                            label={t('profile.defaultView')}
                            sx={{ width: '90%', color: undefined}}
                            helperText={t('profile.groupDefaultViewDesc')}
                        >
                                <MenuItem value={UIViewEnum.None}>
                                    Use Group Default
                                </MenuItem>

                            {
                            groupViews.map((o, ndx) => (
                                <MenuItem key={ndx} value={o.Value}>
                                    {o.Key}
                                </MenuItem>
                            ))
                            }
                        </FormSelect>


                    </Grid>



                     <Grid size={{ xs: 12 }}>

                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {getObjectTypeName(eLynxObjectTypeEnum.Device)}
                        </Typography>

                        <FormSelect
                            name="defaultDeviceView"
                            label={t('profile.defaultView')}
                            sx={{ width: '90%' }}
                        >
                            <MenuItem value={UIViewEnum.None}>
                                Use Device Default
                            </MenuItem>

                            {
                            deviceViews.map((o, ndx) => (
                                <MenuItem key={ndx} value={o.Value}>
                                    {o.Key}
                                </MenuItem>
                            ))
                            }
                        </FormSelect>
                    </Grid>


                     <Grid size={{ xs: 12 }}>

                        <FormSelect
                            name="deviceView"
                            id="devmobileview"
                            label={t('profile.deviceViewMobile.label')}
                            sx={{ width: '90%' }}
                        >
                            <MenuItem value={0}>
                                {t('profile.deviceViewMobile.all')}
                            </MenuItem>
                            <MenuItem value={1}>
                                {t('profile.deviceViewMobile.summary')}
                            </MenuItem>
                        </FormSelect>
                    </Grid>


                     <Grid size={{ xs: 12 }}>

                        <FormSelect
                            name="collapseTagGroups"
                            id="collapsetaggroups"
                            label={t('profile.collapseTagGroups.label')}
                            sx={{ width: '90%' }}
                        >
                            <MenuItem value={1}>
                                {t('profile.collapseTagGroups.collapsed')}
                            </MenuItem>
                            <MenuItem value={0}>
                                {t('profile.collapseTagGroups.expanded')}
                            </MenuItem>
                        </FormSelect>

                    </Grid>


                    <Grid size={{ xs: 12 }}>
                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {getObjectTypeName(eLynxObjectTypeEnum.Tag)}
                        </Typography>

                        <FormSelect
                            name="tagView"
                            id="tagview"
                            label={t('profile.deviceViewMobile.label')}
                            sx={{ width: '90%' }}
                        >
                            <MenuItem value={0}>
                                {t('profile.tagHistory.chart')}
                            </MenuItem>
                            <MenuItem value={1}>
                                {t('profile.tagHistory.grid')}
                            </MenuItem>
                        </FormSelect>
    
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <FormSelect
                            name="tankLevelInches"
                            label={t('profile.defaultTankLevelDisplay')}
                            sx={{ width: '90%' }}
                        >
                            <MenuItem value={0}>
                                Feet and Inches (Default)
                            </MenuItem>
                            <MenuItem value={1}>
                                Inches
                            </MenuItem>
                        </FormSelect>
    
                    </Grid>                    
                    
                </Grid>

           </CardContent>
        </Card>
    );
}